import types from './certificationActionsTypes';

export function setCertificatesLoading(isLoading) {
    return { type: types.SET_CERTIFICATES_LOADING, payload: isLoading };
}

export function setSelectedCertification(selectedCertification) {
    return { type: types.SET_SELECTED_CERTIFICATION, payload: selectedCertification };
}

export function setSelectedUser(selectedUser) {
    return { type: types.SET_SELECTED_USER, payload: selectedUser };
}

export function setModeCertificationModal(modeCertificationModal) {
    return { type: types.SET_MODE_CERTIFICATION_MODAL, payload: modeCertificationModal };
}

export function setShowCertificationModal(showCertificationModal) {
    return { type: types.SET_SHOW_CERTIFICATION_MODAL, payload: showCertificationModal };
}

export function resetState() {
    return { type: types.RESET_STATE };
}
